export enum MissionExitMotifCodeEnum {
  customerProjectAbandon = 'customer_project_abandon',
  customerDissatisfaction = 'customer_dissatisfaction',
  customerResumptionByColleague = 'customer_resumption_by_colleague',
  customerCostTooHigh = 'customer_cost_too_high',
  buContractObligationsFailureByCustomer = 'bu_contract_obligations_failure_by_customer',
  buLitigation = 'bu_litigation',
  buLossTrustInCustomer = 'bu_loss_trust_in_customer',
  activityOutsideScope = 'activity_outside_scope',
  activityTermination = 'activity_termination',
  other = 'other'
}

export type MissionExitMotifFilter = MissionExitMotifCodeEnum | 'all' | null;
